import { client } from './client';
/** Run the automated story verifier (Module 2) for a level. */
export function runVerification(levelId) {
    return client.post(`/levels/${levelId}/verify`, {});
}
/** Deterministically auto-fix the mechanically-fixable findings, then re-verify. */
export function runRepair(levelId) {
    return client.post(`/levels/${levelId}/repair`, {});
}
